import React from "react";

import { Box, styled } from "@mui/material";
import { LiLink } from "../common/commonComps";
import FlexBox from "./account/components/FlexBox";
import type { Size, AdminConfig } from "../types";

const Wrap = styled(Box)(() => ({
    color: `#D4D4D4`,
    background: `#303030`,
    fontSize: 14,

    marginBottom: sessionStorage.getItem(`edit`) ? `40px` : 0,
    marginTop: `auto`,
}));

const SpaceDown = styled(Box)({
    height: `40px`,
    width: `100%`,
    background: `#FFF`,
    marginBottom: `40px`,
});

const InnerWrap = styled(Box)({
    display: `flex`,
    margin: `0 auto`,
    justifyContent: `center`,
    flexDirection: `column`,
    width: `100%`,
    alignItems: `center`,
    maxWidth: `1440px`,
    padding: `0 15px 40px`,
});

const Separator = styled(Box)({
    backgroundColor: `#646464`,
    width: `100%`,
    height: `1px`,
    margin: `30px 0`,
});

const BottomRail = styled(Box)({
    maxWidth: `500px`,
    color: `inherit`,
    width: `100%`,
    fontSize: `inherit`,
    display: `flex`,
    justifyContent: `space-between`,
    flexDirection: `horizontal` as React.CSSProperties[`flexDirection`],
});

const TextLine = styled(Box)<{ size: Size }>(({ size }) => ({
    display: `flex`,
    justifyContent: `center`,
    flexDirection: size === `large` ? `row` : `column`,
    ...(size === `large` ? {} : { maxWidth: `300px`, alignItems: `center` }),
}));

const FooterItem = styled(Box)({
    verticalAlign: `middle`,
    display: `inline-block`,
    cursor: `pointer`,
    color: `inherit`,
    whiteSpace: `nowrap`,
    fontSize: `inherit`,
    textDecoration: `underline`,
});

const DoNotSell = styled(Box)({
    marginTop: `30px`,
    color: `inherit`,
    fontSize: `inherit`,
});

const Footer = ({ adminConfig, size }: { adminConfig?: AdminConfig; size: Size }) => (
    <Wrap id="footer">
        <SpaceDown />
        <InnerWrap>
            <BottomRail>
                <LiLink
                    nopadding
                    nohover
                    sx={{ color: `inherit`, fontSize: `inherit` }}
                    target="_blank"
                    to={adminConfig?.mall?.content_page_links?.terms_of_use_url ?? ``}
                >
                    <FooterItem>Terms Of Use</FooterItem>
                </LiLink>
                <LiLink
                    nopadding
                    nohover
                    sx={{ color: `inherit`, fontSize: `inherit` }}
                    target="_blank"
                    to={adminConfig?.mall?.content_page_links?.privacy_policy_url ?? ``}
                >
                    <FooterItem>Privacy Policy</FooterItem>
                </LiLink>
                <LiLink
                    nopadding
                    nohover
                    sx={{ color: `inherit`, fontSize: `inherit` }}
                    target="_blank"
                    to={adminConfig?.mall?.content_page_links?.contact_us_url ?? ``}
                >
                    <FooterItem>Contact Us</FooterItem>
                </LiLink>
            </BottomRail>
            <Separator />
            <TextLine size={size}>
                <Box
                    component="img"
                    src="https://li-mall-images.s3.us-east-1.amazonaws.com/hostedassets/67b7a6b800437ab432df943b_cb-for-email-footer.avif"
                    display="inline"
                    sx={{
                        ...(size === `large`
                            ? {
                                  height: `100%`,
                                  width: `auto`,
                                  marginRight: `30px`,
                              }
                            : {
                                  height: `auto`,
                                  width: `100px`,
                                  marginBottom: `30px`,
                              }),
                    }}
                />
                <FlexBox sx={{ flexDirection: `column`, justifyContent: `space-between` }}>
                    <Box
                        sx={{ color: `inherit`, fontSize: `inherit`, textAlign: size === `large` ? `left` : `center` }}
                    >
                        Copyright © {new Date().getFullYear()}, loyalty innovation LLC, dba CashBack Rewards. All rights
                        reserved.
                    </Box>
                    <Box
                        sx={{ color: `inherit`, fontSize: `inherit`, textAlign: size === `large` ? `left` : `center` }}
                    >
                        400 Chesterfield Center, Suite 500, Chesterfield, MO 63017
                    </Box>
                </FlexBox>
            </TextLine>
            <DoNotSell>
                <LiLink
                    nopadding
                    nohover
                    sx={{ color: `inherit`, fontSize: `inherit`, textDecoration: `underline` }}
                    target="_blank"
                    to="https://www.getcashbackrewards.com/privacy#state-privacy"
                >
                    <FooterItem>Do Not Sell or Share My Personal Information</FooterItem>
                </LiLink>
            </DoNotSell>
        </InnerWrap>
    </Wrap>
);

export default Footer;
